module.exports = __webpack_public_path__ + "img/goldrush-locked.550bb708.png";